// export.guard — logika kontrol export (dipasang ke ui-kit/export-guard via shell).
// Owner: bebas. Manager/SPV: hanya menu yang izin export-nya DIBUKA Owner di Hak Akses (bawaan: tertutup).
// SPV tanpa izin: masih bisa mengajukan approval sekali-pakai. CS/Finance/Teknisi/Supplier: selalu blok.
import { currentUser } from '@core/session';
import { menuAktif } from '@core/nav';
import { bisaUbah } from '@core/perms';
import { toast } from '@ui/toast';
import { pushNotif } from '@core/notif';
import { logAudit } from '@core/audit';
import { canRequestExport, mayExportAtAll } from '@domain/exportPolicy';
import * as repo from './export.repo';

export async function exportGuard(filename: string): Promise<boolean> {
  const u = currentUser(); if (!u) return false;
  // Izin export PER MENU (Apo 21 Jul): dicabut di layar Hak Akses → tak bisa mengunduh dari
  // menu itu, sekalipun perannya Manager. Dicek di sini karena semua unduhan lewat satu pintu.
  const menu = menuAktif();
  // Izin per-menu = OTORITASNYA (Apo 28 Jul). Bawaannya kini TERTUTUP untuk semua peran selain Owner
  // (anti-pencurian data, terutama pelanggan); Owner membuka per-menu di layar Hak Akses. Peran yang
  // memang tak pernah boleh mengunduh massal (CS/Finance/Teknisi/Supplier) tetap diblok oleh
  // `mayExportAtAll` sekalipun izinnya keliru diberikan — dua lapis, bukan satu.
  const izin = bisaUbah(`${menu}.export`);
  if (izin && mayExportAtAll(u.role)) { void logAudit({ action: 'EXPORT', module: 'export', refId: filename }); return true; }
  if (!canRequestExport(u.role)) {
    void logAudit({ action: 'EXPORT_DENIED', module: 'export', refId: `${filename} (menu ${menu} · peran ${u.role}${izin ? '' : ' · izin tertutup'})` });
    toast(izin ? '⛔ Peran Anda tidak boleh mengunduh data.' : '⛔ Export dari menu ini belum diizinkan — minta Owner membukanya di Hak Akses.');
    return false;
  }
  // SPV tanpa izin menu → masih boleh MENGAJUKAN approval (jalur lama, sekali pakai).
  // SPV: pakai token approved bila ada (single-use)
  const tok = await repo.findApprovedToken();
  if (tok && await repo.consumeToken(tok.id, filename)) {
    void logAudit({ action: 'EXPORT', module: 'export', refId: `${filename} (approval #${tok.id})` });
    toast('✅ Token approval export terpakai — file diunduh.');
    return true;
  }
  // Belum ada token → ajukan approval
  try {
    await repo.requestExport(filename);
    await pushNotif('SPV', u.outlet, `📤 ${u.nama} minta approval EXPORT (${filename}) — perlu persetujuan Owner/Manager.`, '');
  } catch (e) { toast((e as Error).message); return false; }
  toast('📤 Permintaan export dikirim — tunggu approval Owner/Manager, lalu export lagi.');
  return false;
}
